import { useEffect } from "react";

function About() {
  useEffect(() => {
    document.title = "kdo.me ヾ( ˃ᴗ˂ )◞ • *✰";
  }, []);

  return (
    <div>
      <img src="/images/leica.jpg" alt="my pic" width="255" height="auto" />
      <br/>
      <br/>
      <p>
        i'm Nicholas, originally from Hanoi, Vietnam. i first learned how to code while
        doing science fair in high school, where i built my first ever digital health app. since then,
        i've kept growing as software engineer and computer scientist, hoping to create affordable, inclusive technologies
        that help everyone break down barriers and reach their full potential. (ง•̀.•́)ง
        <br />
        <br />
        i'm a curious and fast learner who's always up for new challenges. i've interned at Amazon Web Services, contributed to
        research projects in computer science and public health, created websites for non-profits, and enjoyed hackathons - both as a participant and an organizer.
        <br />
        <br />
        outside of work, i love reading, traveling, taking photos, and experimenting different drinks (hoping to open my own coffee shop someday). you can usually find me taking long walks,
        sitting in a coffee shop all day, and trying to craft a random idea out of my head.
        ˙✧˖°📷 ༘ ⋆｡˚.
      </p>
      <p>
        <h2>currently</h2>
      </p>
      <p>
        i'm a senior at{" "}
        <a href="https://www.unc.edu/" target="_blank" rel="noreferrer" class="clickable">
          unc-chapel hill 🐏
        </a>
        , working on my {" "} <a href="https://cs.unc.edu/" target="_blank" rel="noreferrer" class="clickable">computer science 🖥️</a> and{" "}
        <a href="https://datascience.unc.edu/" target="_blank" rel="noreferrer" class="clickable">data science 📊</a> degree! 🩵
        <br />
        <br />
        at school, i've also TA-ed for computer science & data science classes
        <br />
      </p>
      <p>
        <h2>i've also dabbled in</h2>
        <p>some internships</p>
      </p>
      <ul>
        <li>
          improved aws services integration to deliver multi-account customer experience (
          <a
            href="https://aws.amazon.com/organizations/"
            class="clickable"
            target="_blank"
            rel="noreferrer"
          >
            aws organizations
          </a>
          )
        </li>
        <li>
          improved aws authentication platform - passwords and credentials management services (
          <a
            href="https://aws.amazon.com/iam/identity-center/"
            class="clickable"
            target="_blank"
            rel="noreferrer"
          >
            aws identity
          </a>
          )
        </li>
        <li>
          created websites for non-profits (
          <a
            href="https://www.developforgood.org/?gad_source=1&gclid=CjwKCAjw17qvBhBrEiwA1rU9w1hYghMW1CtS04zqAlNYKxDJpogjQdA3uJmktljnX9y-lx26vqhkKhoC5JwQAvD_BwE"
            class="clickable"
            target="_blank"
            rel="noreferrer"
          >
            develop for good
          </a>
          )
        </li>
        <li>
          worked full-stack on a travelling app (
          <a
            href="https://apps.apple.com/lt/app/campdi/id1637548437"
            class="clickable"
            target="_blank"
            rel="noreferrer"
          >
            campdi - fpt digital
          </a>
          )
        </li>
        <li>
          launched new game features for vietnam's largest streaming platform (
          <a
            href="https://fptplay.vn/"
            class="clickable"
            target="_blank"
            rel="noreferrer"
          >
            fpt play - fpt digital
          </a>
          )
        </li>
      </ul>
      <p>some research projects</p>
      <ul>
        <li>working on AI-powered paper recommendation system for researchers @ UNITES lab</li>
        <li>
        analyzed sentiments of historical{" "} <a
            href="https://nytvietnamwarsnlp.shorthandstories.com/a-comparative-analysis-of-the-evolution-of-new-york-times-vietnam-war-coverage-pre-and-post-pentagon-papers-release/index.html"
            class="clickable"
            target="_blank"
            rel="noreferrer"> contents </a>  @ denison digital humanities
        </li>
      </ul>
      <p>some clubs</p>
      <ul>
        <li>
          built cool stuffs while promoting diversity and inclusion in tech at{" "}
          <a
              href="https://pearlhacks.com/"
              target="_blank"
              rel="noreferrer"
              class="clickable"
            >
            pearl hacks
          </a>
      </li>
      <li>
        developed offline self-exam reminder app helping prevent breast cancer at{" "}
          <a
            href="https://cssgunc.org/"
            target="_blank"
            rel="noreferrer"
            class="clickable"
          >
            cs+social good
          </a>
      </li>
      </ul>
      <p>still don't know who i am? see what{" "}
        <a
          href="https://www.16personalities.com/intj-personality"
          target="_blank"
          rel="noreferrer"
          class="clickable">16personalities</a> said about me!
      </p>
    </div>
  );
}

export default About;
